<div class="account-picker" #popupRef>
    <button
        mat-flat-button
        extended
        id="account-picker-button"
        (click)="toggleDropdown()"
        [attr.aria-label]="selectedAccount?.parentcustomerid_account?.name || 'Vælg forsyning'"
        [attr.aria-expanded]="isOpen"
        aria-haspopup="true"
        aria-controls="account-picker-dropdown"
        type="button"
    >
        <mat-icon class="material-symbols-outlined" aria-hidden="true">factory</mat-icon>
        <div class="icon-wrapper">
            Vælg forsyning
            <mat-icon [class]="isOpen ? 'icon icon--rotate material-symbols-outlined' : 'icon material-symbols-outlined'" aria-hidden="true">
                keyboard_arrow_down
            </mat-icon>
        </div>
    </button>

    @if (isOpen) {
        <div id="account-picker-dropdown" class="account-picker__dropdown" role="menu" aria-labelledby="account-picker-button">
            @for (account of accounts(); track account.contactid; let index = $index) {
                <button
                    #accountPickerButton
                    (click)="selectAccount(account)"
                    [attr.id]="'account-link-button-' + index"
                    [attr.data-testid]="'account-link-button' + index"
                    class="account-picker__button"
                    [class]="account.parentcustomerid_account.accountid === activeAccountId ? 'active' : ''"
                    [attr.aria-label]="'Vælg konto: ' + account.parentcustomerid_account.name"
                    type="button"
                    role="menuitem"
                    (keydown)="onKeydown($event, index)"
                    [attr.data-index]="index"
                >
                    {{ account.parentcustomerid_account.name }}
                </button>
            }
        </div>
    }
</div>
